const lang = {
  component: {
    ChatbotPopup: {
      pTagFirst: `Olá, meu nome é Alma.`,
      pTagSecond: `Fui criada para responder às suas perguntas sobre`,
      pTagThird: `crescimento infantil`,
      pTagFourth: `. Como posso ajudar?`,
      button: {
        copy: `Pergunte para Alma`,
        label: `Faça uma pergunta`
      }
    },
    Chatbot: {
      promptBtnLabel: `Converse com Alma`,
      disclaimer: `As informações que você compartilha nos ajudam a fornecer respostas úteis para mais informações. Confira nossa`,
      privacyPolicy: `política de privacidade.`,
      submitBtnTxt: `Enviar`
    }
  }
};

export default lang;
